module.exports = __webpack_public_path__ + "img/img_title_b@2x.77970dac.png";